import { User } from "firebase/auth";

/**
 * Check if user's email is verified
 * Google login users are automatically considered verified
 * Email/Password users must verify their email
 */
export function isEmailVerified(user: User | null): boolean {
  if (!user) return false;
  
  // Check if user signed in with Google
  const hasGoogleProvider = user.providerData.some(
    (provider) => provider.providerId === "google.com"
  );
  
  // Google users are automatically verified
  if (hasGoogleProvider) return true;
  
  // For email/password users, check emailVerified flag
  return user.emailVerified === true;
}

/**
 * Get the provider type for a user
 */
export function getUserProvider(user: User | null): string {
  if (!user || !user.providerData.length) return "unknown";
  return user.providerData[0].providerId;
}

/**
 * Check if user needs email verification
 * Returns true if user is logged in with email/password and hasn't verified
 */
export function needsEmailVerification(user: User | null): boolean {
  if (!user) return false;
  
  const provider = getUserProvider(user);
  
  // Only email/password users need verification
  if (provider === "password") {
    return !user.emailVerified;
  }
  
  return false;
}
